module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/feature_02-c7e689de8973facc98dfb9630e1cdbd7.png";